/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Training_Consultation_TermsInputs */

const en_service_type_training_consultation_terms = /** @type {(inputs: Service_Type_Training_Consultation_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fitness assessment, movement assessment, first session, trainer consultation`)
};

const pl_service_type_training_consultation_terms = /** @type {(inputs: Service_Type_Training_Consultation_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`konsultacja z trenerem, ocena sprawności, test sprawności, analiza ruchu, pierwszy trening, diagnostyka treningowa`)
};

/**
* | output |
* | --- |
* | "fitness assessment, movement assessment, first session, trainer consultation" |
*
* @param {Service_Type_Training_Consultation_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_training_consultation_terms = /** @type {((inputs?: Service_Type_Training_Consultation_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Training_Consultation_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_training_consultation_terms(inputs)
	return en_service_type_training_consultation_terms(inputs)
});